import { useState, useCallback } from 'react';
import { GridApi, GridReadyEvent } from 'ag-grid-community';

const useGridApi = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const onGridReady = useCallback(({ api }: GridReadyEvent) => {
    setGridApi(api);
  }, []);

  return {
    gridApi,
    onGridReady,
  };
};

export default useGridApi;
